// extracted by mini-css-extract-plugin
export default {"content":"ButtonCircle_content__ox71j","icon":"ButtonCircle_icon__8xMn1"};